// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__PT-gc","modalHeader":"modal_modalHeader__IRUDH"};